import httpClient from './httpClient';

// Types for Activity API response
export interface InterviewDetails {
  interview_type: string;
  context_used: boolean;
  token_free: boolean;
  difficulty?: string;
  experience_focus?: string;
  mode?: string;
}

export interface GDDetails {
  topic: string;
  category: string;
  difficulty: string;
  topic_id: string;
}

export interface CodingDetails {
  challenge_name?: string;
  language: string;
  difficulty: string;
  mode?: string;
  challenge_id?: string;
}

export interface FeedbackSummary {
  overall_score: number;
  readiness_level: string;
  performance_summary: string;
}

export interface ActivitySession {
  session_id: string;
  session_type: 'Interview' | 'GD' | 'Coding';
  status: 'completed' | 'inuse' | 'created' |'abandoned';
  created_at: string;
  updated_at: string;
  candidate_name: string;
  total_questions: number;
  conversation_count: number;
  token: string;
  interview_details?: InterviewDetails;
  gd_details?: GDDetails;
  coding_details?: CodingDetails;
  feedback_summary: FeedbackSummary | null;
}

export interface ActivitySummary {
  by_status: {
    completed: number;
    inuse: number;
    created: number;
  };
  by_type: {
    Interview: number;
    GD: number;
    Coding?: number;
  };
}

export interface ActivityResponse {
  success: boolean;
  activity: ActivitySession[];
  total_sessions: number;
  timestamp: string;
  summary: ActivitySummary;
}

// API functions
export const activityApi = {
  /**
   * Get user's activity history
   * GET /api/getActivity
   */
  async getActivity(): Promise<ActivityResponse> {
    const response = await httpClient.get('getActivity');
    return response.data;
  },
};

// Error handling helper
export const handleActivityError = (error: any): string => {
  if (error.response?.data?.detail) {
    return error.response.data.detail;
  }

  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  if (error.response?.status === 401) {
    return 'Authentication failed. Please log in again.';
  }

  if (error.response?.status === 404) {
    return 'Activity data not found.';
  }

  if (error.response?.status === 500) {
    return 'Server error. Please try again later.';
  }

  if (error.code === 'NETWORK_ERROR' || !error.response) {
    return 'Network error. Please check your connection.';
  }

  return 'An unexpected error occurred. Please try again.';
};

export default activityApi;
